(function (wnd) {
	'use strict';

	wnd.mx = wnd.mx || {};
	wnd.mx.shell = wnd.mx.shell || {};

	/**
	 * @ngdoc enum
	 * @name mx.shell.DisplayMode
	 * @module mx.shell
	 *
	 * @description
	 * Represents a set of predefined application display modes.
	 */
	wnd.mx.shell.DisplayMode = {
		/**
		 * @ngdoc property
		 * @name mx.shell.DisplayMode#BigScreen
		 */
		BigScreen: 1,

		/**
		 * @ngdoc property
		 * @name mx.shell.DisplayMode#Normal
		 */
		Normal: 0,
	};
})(window);
